var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5625H3C2.72386 5.5625 2.5 5.78636 2.5 6.0625V13.0625C2.5 13.3386 2.72386 13.5625 3 13.5625H13C13.2761 13.5625 13.5 13.3386 13.5 13.0625V6.0625C13.5 5.78636 13.2761 5.5625 13 5.5625Z",
    stroke: "#5A646B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.5625V3.3125C5.75 2.71576 5.98705 2.14347 6.40901 1.72151C6.83097 1.29955 7.40326 1.0625 8 1.0625C8.59674 1.0625 9.16903 1.29955 9.59099 1.72151C10.0129 2.14347 10.25 2.71576 10.25 3.3125V5.5625",
    stroke: "#5A646B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.3125C8.41421 10.3125 8.75 9.97671 8.75 9.5625C8.75 9.14829 8.41421 8.8125 8 8.8125C7.58579 8.8125 7.25 9.14829 7.25 9.5625C7.25 9.97671 7.58579 10.3125 8 10.3125Z",
    fill: "#5A646B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.2d2498f8f181108f068601b46d341377.svg";
export { ForwardRef as ReactComponent };